import classes from './Security.module.scss';
import Markdown from 'markdown-to-jsx';

export default function Security({ data }) {
    const { title, copy } = data[0];

    return (
        <div className={`${classes.oSecuritySectionBlock} fontRTL`}>
            <div>
                <h3 className={`${classes.aTitle} fnt24f fnt-b`}>{title || ''}</h3>
                <Markdown className={`${classes.aText} ${classes.aDescriptionText} fnt16f`}>
                    {copy || ''}
                </Markdown>
            </div>
        </div>
    );
}
